import { render, staticRenderFns } from "./NewProjectReview.vue?vue&type=template&id=5af3599b&scoped=true"
import script from "./NewProjectReview.vue?vue&type=script&lang=js"
export * from "./NewProjectReview.vue?vue&type=script&lang=js"
import style0 from "./NewProjectReview.vue?vue&type=style&index=0&id=5af3599b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af3599b",
  null
  
)

export default component.exports